import { render, staticRenderFns } from "./AdditionalResources.vue?vue&type=template&id=62e298f4&"
import script from "./AdditionalResources.vue?vue&type=script&lang=js&"
export * from "./AdditionalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports